import * as z from 'zod';

/* ── KPI Metric Item ──────────────────────────────────────────────────────── */

export const dashboardMetricSchema = z.object({
  label: z.string(),
  value: z.string(),
  raw: z.number().optional(),
});
export type DashboardMetric = z.infer<typeof dashboardMetricSchema>;

export const dashboardDistanceMetricSchema = z.object({
  label: z.string(),
  value: z.string(),
  avgKm: z.number().optional(),
  maxKm: z.number().optional(),
});
export type DashboardDistanceMetric = z.infer<typeof dashboardDistanceMetricSchema>;

export const dashboardKpisSchema = z.object({
  totalOrders: dashboardMetricSchema,
  totalRevenue: dashboardMetricSchema,
  newClients: dashboardMetricSchema,
  newCouriers: dashboardMetricSchema,
  averageCheck: dashboardMetricSchema,
  averageDistance: dashboardDistanceMetricSchema,
});
export type DashboardKpis = z.infer<typeof dashboardKpisSchema>;

/* ── Sales Series ─────────────────────────────────────────────────────────── */

export const salesPointSchema = z.object({
  date: z.string(),
  label: z.string(),
  value: z.number(),
});
export type SalesPoint = z.infer<typeof salesPointSchema>;

export const dashboardSalesSchema = z.object({
  title: z.string(),
  total: z.string(),
  periodLabel: z.string(),
  points: z.array(salesPointSchema),
  yTicks: z.array(z.number()).default([50000, 40000, 30000, 20000, 10000]),
});
export type DashboardSales = z.infer<typeof dashboardSalesSchema>;

/* ── Courier Tracking ─────────────────────────────────────────────────────── */

export const courierSegmentSchema = z.object({
  id: z.string(),
  label: z.string(),
  percentage: z.number(),
  count: z.number().optional(),
  color: z.string(),
});
export type CourierSegment = z.infer<typeof courierSegmentSchema>;

export const courierTrackingSchema = z.object({
  title: z.string(),
  totalCouriers: z.number().optional(),
  segments: z.array(courierSegmentSchema),
});
export type CourierTracking = z.infer<typeof courierTrackingSchema>;

/* ── Full Dashboard Payload ───────────────────────────────────────────────── */

export const dashboardSummarySchema = z.object({
  dateText: z.string().default('23 июня 2026'),
  tab: z.string().default('eats'),
  kpis: dashboardKpisSchema,
  sales: dashboardSalesSchema,
  courierTracking: courierTrackingSchema,
});
export type DashboardSummary = z.infer<typeof dashboardSummarySchema>;

/* ── Request Params ───────────────────────────────────────────────────────── */

export const dashboardParamsSchema = z.object({
  tab: z
    .enum(['eats', 'cargo', 'drive', 'all', 'top_couriers', 'top_vendors'])
    .default('eats'),
  period: z.enum(['week', 'month', 'year']).default('week'),
  date: z.string().optional(),
});
export type DashboardParams = z.infer<typeof dashboardParamsSchema>;
